import {ListeChoix} from "../../../shared/ListeChoix/listeChoix.model";
import {User} from "../../../shared";

export class Preavis {
    constructor(
        public  id: number,
        public  candidatureFormationId: number,
        public  fournisseur: User,
        public  choix: ListeChoix,
        public  commentaire: String,
        public   dateCreation: any,
        public   dateModification: any
    ) {
    }

    static buildListePreavis(
        currentUserId: Number,
        preavisVisuAllEnabled: boolean,
        preavisModifEnabled: boolean,
        candidatureFormationId: number,
        listePreavisExistants: Preavis[],
        lecteurs: User[],
        responsables: User[]): Preavis[] {

        let listePreavis: Preavis[] = [];
        let avisDejaRedige = false;

        // Chargement de l'ensemble des préavis que peut consulter l'utilisateur connecté

        if (candidatureFormationId != null && listePreavisExistants != null && listePreavisExistants.length > 0) {
            const responsable: User = responsables.find(responsable => responsable.id === currentUserId);
            listePreavisExistants.forEach(preavis => {
                if (responsable != null || preavis.fournisseur.id === currentUserId) {
                    listePreavis.push(preavis);
                    if(preavis.fournisseur.id === currentUserId) {
                        avisDejaRedige = true;
                    }
                }
            });
        }

        // Si l'utilisateur est lecteur, il faut lui charger une entrée de préavis vierge pour qu'il puisse en saisir un

        if(lecteurs !== null && lecteurs !== undefined && !avisDejaRedige) {
            const lecteur: User = lecteurs.find(lecteur => lecteur.id === currentUserId);
            if(lecteur != null) {
                listePreavis.push(new Preavis(
                    null,
                    candidatureFormationId,
                    lecteur,
                    null,
                    null,
                    null,
                    null
                ));
            }
        }
        if(listePreavis !== null && listePreavis.length > 1) {
            listePreavis.sort((p1, p2) =>
                p1.fournisseur.id === currentUserId ? 1 :
                    (p2.fournisseur.id === currentUserId ? -1 : p1.id - p2.id));
        }
        return listePreavis;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/preavis/preavis.model.ts